jQuery(document).ready(function($) {
  var accordion = {

    construct: function() {
      this.accordion = $('.accordion-toggle');
      this.foundationAccordion = null;
      this.accordionItems = $('.accordion-toggle li');
      this.images = $('[data-accordion-toggle]');
      this.accordionItems.on('click', this.toggleImages.bind(this));
      this.accordionIsInitialized = true;
      $(window).on('load resize orientationchange', this.respondToResize.bind(this));
    },

    toggleImages: function(event) {
      this.images.each(function(i, img) {
        $(img).addClass('absolute');
      })
      $(this.images.get(this.accordionItems.index(event.currentTarget))).removeClass('absolute');
    },


    respondToResize: function() {
      if (window.innerWidth <= 767 && this.accordionIsInitialized) {
        this.accordion.foundation('_destroy');
        this.accordionIsInitialized = false;
      } else if (window.innerWidth > 767 && !this.accordionIsInitialized) {
        this.foundationAccordion = new Foundation.Accordion(this.accordion);
        this.accordionIsInitialized = true;
      }
    }

  }

  $.fn.exists = function () {
    return this.length !== 0;
  }

  if ($('.accordion-toggle').exists()) {
    accordion.construct();
  }

})
